import { ApiProvider } from '@/provider/ApiProvider';

export async function getBrandListById(brandId) {
  try {
    const response = await ApiProvider.webserviceGet('Brands/GetBrands?brand_id=' + brandId);
    if (response.success) {
      return response.data; // Return the brand list
    } else {
      return []; // Return an empty array if the API fails
    }
  } catch (error) {
    ApiProvider.globalToastMessage(error.message, 5000, 'error');
    throw error; // Propagate the error
  }
}
